<template>
<div v-bind:class="{'ui loading form': (loaded==1)}">
  <form class="ui form segment">
    <app-header v-if="showMenu" ></app-header>
    <div class="ui block header">
      
      <div class="four fields">
        <div class="field">
            <label>Application</label>
              <label >{{ this.application_name }} </label>
          </div>
          <div class="field">
            <label>GUID</label>
              <label >{{ this.guid }}</label>
          </div>
          <div class="field">
            <label>TimeStamp</label>
            <label >{{ this.error_time }}</label>
          </div>
          <div class="field">
            <label>Document#</label>
              <label >{{ this.document_number }}</label>
          </div>
      </div>

       <div class="four fields">
        <div class="field">
            <label>Error Code:</label>
              <label >{{ this.error_code }} </label>
          </div>
          <div class="field">
            <label>Server:</label>
              <label >{{ this.server }}</label>
          </div>
          <div class="field">
            <label>Receive Port:</label>
            <label >{{ this.receive_port }}</label>
          </div>
          <div class="field">
            <label>Send Port:</label>
              <label >{{ this.send_port }}</label>
          </div>
      </div>

      <div class="four fields">
        <div class="field">
            <label>Document Type:</label>
              <label >{{ this.doc_type }}</label>
          </div>
          <div class="field">
            <label>Scope:</label>
            <label >{{ this.error_scope }}</label>
          </div>
          <div class="field">
            <label>Error Status:</label>
              <label >{{ this.status }}</label>
          </div>
      </div>

       <div class="one field">
        
          <div class="field">
            <label>File Received:</label>
              <label >{{ this.received_file }} </label>
          </div>
      </div>
       <div class="one field">
        
          <div class="field">
            <label>Error Description:</label>
              <label >{{ this.error_description }} </label>
          </div>
      </div>

    </div>


  
    <div :class="[{'vuetable-wrapper ui basic segment': true}, loading]">
   <div class="ui attached segment">
       <vuetable ref="vuetable"
                api-url= "retrieveassigneduserstoerror/"
                :http-options="httpOptions"
                :http-fetch="fetchAssignedUsers"
                :fields="fields"
                :table-height="tableHeight"
                pagination-path="pagination"
                :per-page="perPage"
                :append-params="moreParams"
                :row-class="rowClassCB"
                detail-row-transition="expand"
                @vuetable:load-success="onLoadSuccess"
                 @vuetable:load-error="onLoadError"
                @vuetable:loading="showLoader"
                @vuetable:loaded="hideLoader"
                @vuetable:cell-clicked="onCellClicked"
                @vuetable:initialized="onInitialized"
                @vuetable:data-reset="onDataReset"
                track-by="id">
       </vuetable>
   </div>
    </div>

  <div class="ui attached segment">
  <div class="four fields">
   <div class="field">
      <label>Assign To</label>
      <select class="ui dropdown" v-model="userSelected" style="width:450px" >
       <option v-for="user in users" v-bind:value="user.uid" v-bind:key="user.name" >
        {{ user.name }}
       </option>
      </select>
      
    </div>
    
  
  </div>
  <div class="four fields">
   <div class="field">
      <label>Error Status</label>
      <select class="ui dropdown" v-model="errorStatusSelected" style="width:450px" >
       <option v-for="errorStatus in errorStatuses" v-bind:value="errorStatus.errorStatusId" v-bind:key="errorStatus.errorStatusId" >
        {{ errorStatus.description }}
       </option>
      </select>
      
    </div>
    
  
  </div>


  <div class="four fields">
   <div class="field">
      <label>Notes</label>
     <input placeholder="Notes"  style="width:450px" name="_errorNotes" type="text"  ref="ipErrorNotes"   >
    </div>
    
  
  </div>


 <div class="ui primary submit button"   @click="updateErrorDetails()">Update</div>
          <div class="ui button"  @click="closeWindow()">Close Current Window</div>


</div>
   <div class="ui negative message" v-if="showMessage">
          <div class="header">
           Please correct the following error(s):
          </div>
          <p>
            {{ message_Enter }}
          </p>
      </div>

    </form>
  </div>



 
</template>

<script>
import axios from "axios";
import Header from '@/components/Header.vue';
import Vue from 'vue'
import Vuetable from '@/components/vuetable-2/Vuetable.vue'
import VuetablePagination from '@/components/vuetable-2/VuetablePagination.vue'
import VuetablePaginationDropdown from '@/components/vuetable-2/VuetablePaginationDropdown.vue'
import VuetablePaginationInfo from '@/components/vuetable-2/VuetablePaginationInfo.vue'

let tableColumns = [
  
  {
    name: 'assignedFromUserName',
    title: 'Assigned From',
    dataClass: 'left aligned',
    width: '60px'
  },
  {
    name: 'assignedToUserName',
    dataClass: 'left aligned',
    title: 'Assigned To',
    width: '60px'
 },
 {
    name: 'lastUpdated',
    dataClass: 'left aligned',
    title: 'Last Updated',
    width: '60px'
 },
  {
    name: 'comments',
    dataClass: 'left aligned',
    title: 'Comments',
    width: '100px'
 },
  {
    name: 'description',
    dataClass: 'left aligned',
    title: 'Status',
    width: '40px'
 }
 
]

export default {
  components: {
    appHeader: Header,
    Vuetable,
    VuetablePagination,
    VuetablePaginationDropdown,
    VuetablePaginationInfo
  },
  data () {
    return {
      loaded : "1",
      httpOptions: {
      headers: {
      authorization: ""
      }
    },
      loading: '',
      showMessage : 0,
      showMenu :false,
      headerData : [],
      errorId : "",
      application_name : "" ,
      error_time : "",
      receive_port : "",
      guid : "",
      document_number : "",
      type : "",
      status : "",
      category : "",
      received_file :  "",
      send_port :  "",
      error_code :  "",
      server :  "",
      error_scope :  "",
      doc_type :  "",
      error_description :  "",
      errorStatusSelected : "",
      errorStatuses :[],
      userSelected : "",
      users :[],
           input: {
        refreshtoken : ""
      }   ,
      diffMins : 0,
      refreshToken_Event_Fired : 0 ,
    moreParams: { _filter : '' , _buyer_code : '',_vendor_code : '',_loc_code : '', _corc_code : ''},
    fields: tableColumns,
     tableHeight: '',
    vuetableFields: false,
    paginationComponent: 'vuetable-pagination',
    perPage: 10,
    paginationInfoTemplate: 'Showing record: {from} to {to} from {total} item(s)'
   }
 },
 methods: {
   bindErrorDetails(){
         if(localStorage.getItem('id_token')){
         this.loaded = 1;
         axios({ method: "GET", "url": Vue.prototype.$hostname + "getintegrationerrorlist/-1/" + this.errorId  + "/N", 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.headerData = result.data;
                    console.log(this.headerData);
                    this.application_name = this.headerData[0].application_name;
                    this.error_time = this.headerData[0].error_time;
                    this.receive_port = this.headerData[0].receive_port;
                    this.guid = this.headerData[0].guid;
                    this.document_number = this.headerData[0].document_number;
                    this.type = this.headerData[0].type;
                    this.status = this.headerData[0].status;
                    this.category = this.headerData[0].category;
                    this.received_file =  this.headerData[0].received_file;
                    this.send_port =  this.headerData[0].send_port;
                    this.error_code =  this.headerData[0].error_code;
                    this.server =  this.headerData[0].server;
                    this.error_scope =  this.headerData[0].error_scope;
                    this.doc_type =  this.headerData[0].doc_type;
                    this.error_description =  this.headerData[0].error_description;
               }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
              this.loaded = 2;
        }       
    },
    
    fetchAssignedUsers:function(apiUrl, httpOptions) {
    this.checkTokenExpired();
    this.httpOptions.headers['authorization'] = 'bearer ' +  localStorage.getItem('id_token')
    return axios.get(Vue.prototype.$hostname + apiUrl + CryptoJS.AES.decrypt( this.$route.query.errorId, 'corcentric').toString(CryptoJS.enc.Latin1) , this.httpOptions); 
    },
sessionExpired(errorStatus){
      if (errorStatus === 403 && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Sesssion expired.Please login again!!');
        this.$router.push({name: 'Login'});
    }
   },
transform (data) {
      let transformed = {}
      transformed.pagination = {
        total: data.total,
        per_page: data.per_page,
        current_page: data.current_page,
        last_page: data.last_page,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
        from: data.from,
        to: data.to
      }

      transformed.data = []
      data = data.data

      for (let i = 0; i < data.length; i++) {
        transformed['data'].push({
          id: data[i].errorId,
          assignedFromUserName: data[i].assignedFromUserName,
          assignedToUserName : data[i].assignedToUserName,
          comments: data[i].comments,
          description: data[i].description,
          lastUpdated : data[i].lastUpdated.replace('T', " ")
          })

       

         

      }
       console.log('transformed')
      console.log(transformed)

      return transformed
    },

   closeWindow(){
    window.close();
  },
   showMessages(){
     this.message_Enter = "Please Select ";
     this.showMessage = 0;

     if(this.userSelected == "-1"){
    this.message_Enter = this.message_Enter + " Assign To User";
     this.showMessage = 1;
    }
    if(this.errorStatusSelected == "-1"){
    if (this.message_Enter != "Please enter ")
     this.message_Enter = this.message_Enter + ',';
    this.message_Enter = this.message_Enter + " Error Status";
     this.showMessage = 1;
    }
   

  },
  updateErrorDetails(){
     this.showMessages();
     if(this.showMessage == 0){
        swal({
        title: "",
        text: "Are you sure, to update Error Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Update it!",
        closeOnConfirm: true
        },() => {
         
          axios({ method: "POST", "url": Vue.prototype.$hostname +  "updateerrordetails", 
            "data": {
              error_id : this.errorId ,
              user_id : this.userSelected,
              error_status : this.errorStatusSelected,
              notes : this.$refs.ipErrorNotes.value.trim() ,
                    
            }, 
            "headers": 
            { 
              "content-type": "application/json" ,
              "authorization": "bearer " + localStorage.getItem('id_token') 
            }  }).then
            (
              result => {
                  this.$refs.vuetable.refresh();
                sweetAlert('Data has been updated successfully!', '', 'success')

              }, 
            error => {
            console.error(error);
            this.sessionExpired(error.response.status);
            sweetAlert('Something\'s Wrong!', error, 'error')
            });
      
        
      })
     }
      
    },

   checkTokenExpired(){
    if(this.refreshToken_Event_Fired == 0){
    this.getTokenExpiryTime();/* Get Token Expiry time  in Minutes */
    if(this.diffMins <= Vue.prototype.$session_Expire_in && this.diffMins > 0  ){ /* If Token Expiring in (expires_in from service) Mins,then get refereh token */
      this.refreshToken_Event_Fired = 1 ;
      this.getRefreshToken();
      this.refreshToken_Event_Fired = 0;
    }
     }
    },
    async getRefreshToken() {
    this.input['refreshtoken'] = localStorage.getItem('refresh_token')
    await axios({ method: "POST", "url": Vue.prototype.$appName + "token/refreshtoken", 
      "data": this.input, 
      "headers": { "Access-Control-Allow-Origin" : "*",
      "content-type": "application/json" } }).then
      (
          result => {
          this.response = result.data;
          localStorage.setItem('id_token', result.data.access_token);
          localStorage.setItem('refresh_token', result.data.refresh_token);

          var now = new Date();
          now.setMinutes(now.getMinutes() + Math.floor(result.data.expires_in / 60)  ); // timestamp
          now = new Date(now); // Date object
          localStorage.setItem('expiry_date', now);
         }, 
      error => {
        this.refreshToken_Event_Fired = 0;
        console.error(error);
      });

    },
    getTokenExpiryTime() {
      var expiry_date =  new Date(localStorage.getItem('expiry_date'));
      var today = new Date();
      var diffMs = (expiry_date - today); // milliseconds between now & logintime
      this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
       
    },
    preg_quote ( str ) {
       return (str+'').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    },
    highlight (needle, haystack) {
      return haystack.replace(
        new RegExp('(' + this.preg_quote(needle) + ')', 'ig'),
        '<span class="highlight">$1</span>'
        )
    },
    rowClassCB (data, index) {
      return (index % 2) === 0 ? 'odd' : 'even'
    },
    onCellClicked (data, field, event) {
      this.checkTokenExpired();
      console.log('cellClicked', field.name)
      if (field.name !== '__actions') {
        this.$refs.vuetable.toggleDetailRow(data.id)
      }
    },
    onCellDoubleClicked (data, field, event) {
      console.log('cellDoubleClicked:', field.name)
    },
    onCellRightClicked (data, field, event) {
      console.log('cellRightClicked:', field.name)
    },
    onLoadSuccess (response) {
     // set pagination data to pagination-info component
      this.$refs.paginationInfo.setPaginationData(response.data)
      let data = response.data.data
      if (this.searchFor !== '') {
        for (let n in data) {
          data[n].name = this.highlight(this.searchFor, data[n].name)
          data[n].email = this.highlight(this.searchFor, data[n].email)
        }
      }
    },
    onLoadError (response) {
      if (response.status == 400 &&  this.tokenExpired === 0) {
        sweetAlert('Something\'s Wrong!', response.data.message, 'error')
        his.$router.push({name: 'Login'});
      } else if (response.status == 403 || response.status == 401) {
        this.sessionExpired(response.status)
      }else {
       /* if(this.tokenExpired === 0){sweetAlert('Oops', E_SERVER_ERROR, 'error')*/
        this.$router.push({name: 'Login'});
       /* }*/
      }
    },
    showLoader () {
      this.loading = 'loading'
    },
    hideLoader () {
      this.loading = ''
    },
     onInitialized (fields) {
      console.log('onInitialized', fields)
      this.vuetableFields = fields
    },
    onDataReset () {
      console.log('onDataReset')
      thonInitializedis.$refs.paginationInfo.resetData()
      this.$refs.pagination.resetData()
    },
    bindUsers(){
        if(localStorage.getItem('id_token')){
         axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/getintegrationusers", 
               "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.users = result.data;
                    this.userSelected  = "-1";
                   }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
        } 
    },
    bindErrorStatus(){
        if(localStorage.getItem('id_token')){
         axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/geterrorstatus", 
               "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.errorStatuses = result.data;
                    this.errorStatusSelected  = "-1";
                   }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
        } 
    }

  },
 created() {
     if(!localStorage.getItem('id_token') ){
       this.$router.push({name: 'Login'});
     }else{
     this.checkTokenExpired();
     this.errorId = CryptoJS.AES.decrypt( this.$route.query.errorId, 'corcentric').toString(CryptoJS.enc.Latin1);
     this.bindErrorDetails();
    this.bindUsers();
    this.bindErrorStatus();
     }
  }
}
</script>
 <style type="text/css">
      .ui.vertical.stripe h3 {
        font-size: 2em;
      }
      .secondary.pointing.menu .toc.item {
        display: none;
      }
      .vuetable {
        margin-top: 1em !important;
      }
      .vuetable-wrapper.ui.basic.segment {
        padding: 0em;
      }
      .vuetable button.ui.button {
        padding: .5em .5em;
        font-weight: 400;
      }
      .vuetable button.ui.button i.icon {
        margin: 0;
      }
      .vuetable td i.handle-icon:hover {
        cursor: pointer;
      }
      .vuetable-actions {
        width: 15%;
        padding: 12px 0px;
        text-align: center;
      }
      .vuetable-pagination {
        background: #f9fafb !important;
      }
      .vuetable-pagination-info {
        margin-top: auto;
        margin-bottom: auto;
      }
      .highlight {
        background-color: yellow;
      }
      .vuetable-detail-row {
        height: 200px;
      }
      .detail-row {
        margin-left: 40px;
      }
      .expand-transition {
        transition: all .5s ease;
      }
      .expand-enter, .expand-leave {
        height: 0;
        opacity: 0;
      }
      tr.odd {
        background-color: #e6f5ff;
      }
      body {
        overflow-y: scroll;
      }
    </style>





// WEBPACK FOOTER //
// src/components/integration-errors/updateErrorDetails.vue